@if(!hideHistory && uiConfiguration?.showCollateralHistoryButton) {
  <div class="flex-container-space-between margin-bottom-15">
    <div class="button-container">
      <button mat-flat-button color="primary" (click)="openGeneralCollateralHistory()"
      data-testid="general-collateral-history-button">{{ 'generalCollateral.generalCollateralHistory' | transloco }}</button>
    </div>
  </div>
} @else if(!hideHistory && uiConfiguration?.showEntireCollateralHistory) {
  @if(history.length !== 0) {
    @for (node of history; track node; let i = $index) {
      <div>
        @if(i === 0 || node.collateralValue) {
          <div class="margin-bottom-15">
            @if(node.collateralValue) {
              @if(node.registrationNumber) {
                <div class="light-bold margin-bottom-5">{{ i === 0 ? 'Original' : 'Replaced by registration number' +
                node.registrationNumber }}:</div>
              } @else {
                <div class="light-bold margin-bottom-5">{{ i === 0 ? 'Original' : 'Fully replaced' }}</div>
              }
              <span class="preserve-line-breaks">{{ node.collateralValue }}</span>
            }
          </div>
        }
        @if (i > 0 && node.collateralToAdd) {
          <div class="margin-bottom-15">
            @if(node.registrationNumber) {
              <div class="light-bold margin-bottom-5">{{ 'generalCollateral.addedByRegistrationNumber' | transloco: { number: node.registrationNumber } }}</div>
            } @else {
              <div class="light-bold margin-bottom-5">{{ 'generalCollateral.collateralAdded' | transloco }}</div>
            }
            <span class="preserve-line-breaks">{{ node.collateralToAdd }}</span>
          </div>
        }
        @if (i > 0 && node.collateralToRemove) {
          <div class="margin-bottom-15">
            @if(node.registrationNumber) {
              <div class="light-bold margin-bottom-5">{{ 'generalCollateral.removedByRegistrationNumber' | transloco: { number: node.registrationNumber } }}</div>
            } @else {
              <div class="light-bold margin-bottom-5">{{ 'generalCollateral.collateralRemoved' | transloco }}</div>
            }
            <span class="preserve-line-breaks">{{ node.collateralToRemove }}</span>
          </div>
        }
      </div>
    }
  }
}

@if (uiConfiguration?.showSecurityInterest ?? false) {
  <div class="flex-container margin-bottom-15">
    <mat-checkbox class="flex-item" name="securityInterest" disabled="true"
      [checked]="order.lien?.securityInterest ?? false" data-testid="general-collateral-security-interest-checkbox">
      {{ 'generalCollateral.theSecurityInterestIsTakenIn' | transloco }}</mat-checkbox>
  </div>
}

@if (uiConfiguration?.showSecurityInterestExceptFor ?? false) {
  <div class="flex-container margin-bottom-15">
    <mat-checkbox class="flex-item" name="securityInterestExceptFor" disabled="true"
      [checked]="order.lien?.securityInterestExceptFor ?? false" data-testid="general-collateral-security-interest-checkbox-except-for">
      {{ 'generalCollateral.theSecurityInterestIsTakenIn2' | transloco }}</mat-checkbox>
  </div>
}

@if (order.lien?.generalCollateral?.collateralValue && uiConfiguration?.showCollateralValue) {
  <div>
    <div class="light-bold">
      {{ uiConfiguration?.collateralValueTitle }}:
    </div>
    <div class="preserve-line-breaks" data-testid="general-collateral-replace-with-text">
      {{ order.lien?.generalCollateral?.collateralValue }}
    </div>
  </div>
}
@if (order.lien?.generalCollateral?.collateralToAdd && uiConfiguration?.showCollateralToAdd) {
  <div>
    <div class="light-bold">
      {{ uiConfiguration?.collateralToAddTitle }}:
    </div>
    <div class="preserve-line-breaks" data-testid="general-collateral-add-text">
      {{ order.lien?.generalCollateral?.collateralToAdd }}
    </div>
  </div>
}
@if (order.lien?.generalCollateral?.collateralToRemove && uiConfiguration?.showCollateralToRemove) {
  <div>
    <div class="light-bold">
      {{ 'generalCollateral.removeGeneralCollateral' | transloco }}
    </div>
    <div class="preserve-line-breaks" data-testid="general-collateral-remove-text">
      {{ order.lien?.generalCollateral?.collateralToRemove }}
    </div>
  </div>
}